// extracted by mini-css-extract-plugin
export default {"news":"styles_news__1SRBK","featuredPost":"styles_featuredPost__KW2UR","featuredPostItem":"styles_featuredPostItem__GdIHx","img":"styles_img__wAHcZ","desc":"styles_desc__nqfQx"};